import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import crypto from "crypto";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import Modal from "react-bootstrap/Modal";

import "@app/components/Theme/ECharts";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfoModal: false,
            userName: localStorage.getItem("login_user_name"),
            userId: localStorage.getItem("login_user_id"),
            userType: localStorage.getItem("login_user_type"),
        };
    }

    logout = () => {
        this.props.logoutHandeler();
    };

    showUserInfoModal = (show) => {
        this.setState({
            userInfoModal: show,
        });
    };

    render() {
        return (
            <div className="dashboard-header">
                <nav className="navbar navbar-expand-md nav-light fixed-top">
                    <Link className="navbar-brand-link" to="/">
                        <div className="navbar-brand">
                            TAS
                            <span className="h5 ml-2 mr-2">(Tomo Assistant System)</span>
                            {this.state.userType === "branch" ? "" : "ADMIN"}
                            {process.env.REACT_APP_ENVIRONMENT !== "production" && (
                                <span className="text-danger h5 ml-2 ml-2">
                                    <i className="fas fa-exclamation-triangle"></i>
                                    {`[${process.env.REACT_APP_ENVIRONMENT.toUpperCase()}${process.env.REACT_APP_ENVIRONMENT_DESC ? `-${process.env.REACT_APP_ENVIRONMENT_DESC}` : ""}]`}
                                    <i className="fas fa-exclamation-triangle"></i>
                                </span>
                            )}
                        </div>
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="fas fa-cog fa-lg text-muted"></i>
                    </button>
                    <div className="collapse navbar-collapse " id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto navbar-right-top">
                            <li className="nav-item dropdown nav-user">
                                <Link className="nav-link nav-user-img" to="#" id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fas fa-user-circle"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right nav-user-dropdown" aria-labelledby="navbarDropdownMenuLink2">
                                    <div className="nav-user-info">
                                        <h5 className="mb-0 text-white nav-user-name">{this.state.userName}</h5>
                                    </div>
                                    <a className="dropdown-item" onClick={() => this.showUserInfoModal(true)}>
                                        <i className="fas fa-address-card mr-2"></i>정보 수정
                                    </a>
                                    <a className="dropdown-item" onClick={this.logout}>
                                        <i className="fas fa-power-off mr-2"></i>Logout
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <UserInfoModal
                    userType={this.state.userType}
                    userId={this.state.userId}
                    userName={this.state.userName}
                    show={this.state.userInfoModal}
                    onHide={() => this.showUserInfoModal(false)}
                    onChangePass={() => this.logout()}
                    onChangeUserInfo={(userName) => this.setState({ userName: userName })}
                />
            </div>
        );
    }
}

const UserInfoModal = ({ userType, userId, userName, show, onHide, onChangeUserInfo, onChangePass }) => {
    const [userInfo, setUserInfo] = useState({
        name: userName,
        pass: "",
        newPass: "",
        newPassConfirm: "",
    });

    useEffect(() => {
        return () => {};
    }, [userType, userId, userName, show]);

    if (!userType || !userId) {
        return null;
    }

    const submitUserInfo = () => {
        if (!userInfo.name.trim()) {
            alert("이름에 빈칸은 저장할 수 없습니다.");
            return;
        }

        if (userInfo.name.trim().length > 20) {
            alert("20자 이하로 작성 해주세요.");
            return;
        }

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/user/${userType}/info/${userId}`,
            data: {
                name: userInfo.name.trim(),
            },
        })
            .then((result) => {
                if (result.data.code != "200") {
                    alert(result.data.msg);
                } else {
                    alert("저장 되었습니다.");
                    const u = { ...userInfo };
                    u.pass = "";
                    u.newPass = "";
                    u.newPassConfirm = "";
                    setUserInfo(u);
                    onChangeUserInfo(userInfo.name.trim());
                    onHide();
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const submitPassword = () => {
        if (!userInfo.pass.trim() || !userInfo.newPass.trim() || !userInfo.newPassConfirm.trim()) {
            alert("기존 패스워드, 신규 패스워드, 신규 패스워드 확인 세가지 항목 모두 입력해주세요.");
            return;
        }

        if (userInfo.newPass.trim() !== userInfo.newPassConfirm.trim()) {
            alert("신규 패스워드가 동일하지 않습니다.");
            return;
        }

        if (userInfo.newPass.trim().length < 4 || userInfo.newPass.trim().length > 16) {
            alert("패스워드는 4~16자 입력 가능합니다.");
            return;
        }

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/user/${userType}/pass/${userId}`,
            data: {
                pass: crypto.createHash("md5").update(userInfo.pass).digest("hex"),
                newPass: crypto.createHash("md5").update(userInfo.newPass).digest("hex"),
            },
        })
            .then((result) => {
                if (result.data.code != "200") {
                    alert(result.data.msg);
                } else {
                    alert("패스워드가 수정 되었습니다.\n다시 로그인해주세요.");
                    onChangePass();
                }
            })
            .catch((error) => {
                console.log(error);
                alert("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <Modal show={show} onHide={onHide} aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">{userId} 정보 수정</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {userType !== "branch" && (
                    <>
                        <div className="form-group">
                            <label htmlFor="user_name" className="col-form-label">
                                정보 변경
                            </label>
                            <input
                                id="user_name"
                                type="text"
                                className="form-control"
                                value={userInfo.name}
                                placeholder="이름"
                                onChange={(e) => {
                                    const u = { ...userInfo };
                                    u.name = e.target.value;
                                    setUserInfo(u);
                                }}
                            />
                            <button className="btn btn-primary btn-sm mt-1" onClick={submitUserInfo}>
                                저장
                            </button>
                        </div>
                        <hr />
                    </>
                )}
                <div className="form-group mt-2">
                    <label htmlFor="password" className="col-form-label">
                        패스워드
                    </label>
                    <input
                        id="pass"
                        type="password"
                        className="form-control"
                        placeholder="현재 패스워드"
                        value={userInfo.pass}
                        onChange={(e) => {
                            const u = { ...userInfo };
                            u.pass = e.target.value;
                            setUserInfo(u);
                        }}
                    />
                    <input
                        id="newPass"
                        type="password"
                        className="form-control mt-1"
                        placeholder="신규 패스워드"
                        value={userInfo.newPass}
                        onChange={(e) => {
                            const u = { ...userInfo };
                            u.newPass = e.target.value;
                            setUserInfo(u);
                        }}
                    />
                    <input
                        id="newPassConfirm"
                        type="password"
                        className="form-control mt-1"
                        placeholder="신규 패스워드 확인"
                        value={userInfo.newPassConfirm}
                        onChange={(e) => {
                            const u = { ...userInfo };
                            u.newPassConfirm = e.target.value;
                            setUserInfo(u);
                        }}
                    />

                    <button className="btn btn-primary btn-sm mt-1" onClick={submitPassword}>
                        저장
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Header;
